import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import Navbar from "./components/Navbar";
import Home from './components/Home';
import Catalog from './components/Catalog';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer'; 
import { Analytics } from "@vercel/analytics/react"
import UIUC from './components/pages/UIUC';


function App() {

  return ( 
    <div className="App">
      <Analytics />
      <Navbar/>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} /> {/* use the new component */}
          <Route path="/home" element={<Home />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/uiuc" element={<UIUC />} />
        </Routes>
      </Router>
      <Footer/>
    </div>
  );
}

export default App;